"use server";

import { cookies } from "next/headers";
import { db } from "@/lib/db";
import { revalidatePath } from "next/cache";

export async function adminLogin(password: string) {
    const adminPassword = process.env.ADMIN_PASSWORD || "admin123";
    if (password === adminPassword) {
        const cookieStore = await cookies();
        cookieStore.set("admin_token", password, {
            httpOnly: true,
            secure: process.env.NODE_ENV === "production",
            maxAge: 60 * 60 * 24 * 7, // 1 week
            path: "/"
        });
        return { success: true };
    }
    return { success: false, error: "Invalid admin password" };
}

export async function adminLogout() {
    const cookieStore = await cookies();
    cookieStore.delete("admin_token");
    cookieStore.delete("user_id");
    cookieStore.delete("family_id");
}

export async function toggleUserBlock(userId: string, currentStatus: boolean) {
    await db.user.update({
        where: { id: userId },
        data: { isBlocked: !currentStatus }
    });
    revalidatePath("/admin");
    return { success: true };
}

export async function toggleFamilyBlock(familyId: string, currentStatus: boolean) {
    await db.family.update({
        where: { id: familyId },
        data: { isBlocked: !currentStatus }
    });
    revalidatePath("/admin");
    return { success: true };
}

export async function updateFamilyModules(familyId: string, modules: string[]) {
    await db.family.update({
        where: { id: familyId },
        data: { enabledModules: modules }
    });
    revalidatePath("/admin");
    return { success: true };
}

export async function impersonateFamily(familyId: string) {
    const family = await db.family.findUnique({
        where: { id: familyId },
        include: { members: true }
    });

    if (!family || family.members.length === 0) {
        return { success: false, error: "Family not found or has no members" };
    }

    // Try to find the admin member or fallback to the first member
    const targetMember = family.members.find(m => m.role === "admin") || family.members[0];

    const cookieStore = await cookies();
    cookieStore.set("user_id", targetMember.userId, {
        httpOnly: true,
        secure: process.env.NODE_ENV === "production",
        maxAge: 60 * 60 * 24 * 7,
        path: "/"
    });
    cookieStore.set("family_id", familyId, {
        httpOnly: true,
        secure: process.env.NODE_ENV === "production",
        maxAge: 60 * 60 * 24 * 7,
        path: "/"
    });

    return { success: true };
}

export async function stopImpersonating() {
    const cookieStore = await cookies();
    cookieStore.delete("user_id");
    cookieStore.delete("family_id");
    return { success: true };
}
export async function deleteUser(userId: string) {
    // Delete the user record (cascades to FamilyMember, Permission, PropertyOwnership)
    // Transactions and Categories will have recordedByUserId/createdByUserId set to null
    await db.user.delete({
        where: { id: userId }
    });
    revalidatePath("/admin");
    return { success: true };
}

export async function deleteFamily(familyId: string) {
    // Delete the family record (cascades to all associated data)
    await db.family.delete({
        where: { id: familyId }
    });
    revalidatePath("/admin");
    return { success: true };
}
